var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"coupon-table"},_vm._l((_vm.users),function(user){return _c('div',{staticClass:"itemlist"},[_c('div',{staticClass:"item"},[_c('span',[_vm._v(_vm._s(user.name))]),_c('span',[_vm._v(_vm._s(user.nickName))])]),_c('div',{staticClass:"item"},[_c('span',[_vm._v("核销时间："+_vm._s(user.useTime))])])])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }